import styled from 'styled-components/macro';
import { MOBILE_BREAKPOINT } from '../../app/constants';

export const StyledHorizontalScrollPrompt = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(255,255,255,0.8);
  display: flex;
  justify-content: center;
  padding-top: 200px;
  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    padding-top: 200px;
  }
  .icon-scroll {
    position: relative;
    width: 30px;
    height: 45px;
    display: block;
    transform: rotate(90deg);
    box-shadow: inset 0 0 0 3px;
    border-radius: 25px;
    z-index: 2;
  }

  .icon-scroll:before {
    position: absolute;
    left: 50%;
    content: '';
    width: 8px;
    height: 8px;
    background-color: inherit;
    box-shadow: inset 0 0 0 5px;
    margin-left: -4px;
    top: 7px;
    border-radius: 4px;
    -webkit-animation-duration: 0.8s;
    animation-duration: 0.8s;
    -webkit-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
    -webkit-animation-name: scroll;
    animation-name: scroll;
  }
  @-webkit-keyframes scroll {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
      transform: translateY(25px);
    }
  }
  @keyframes scroll {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
      transform: translateY(25px);
    }
  }
`;
